var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3309 17.4991V15.8327C13.3309 14.9488 12.9797 14.1011 12.3547 13.4761C11.7297 12.8511 10.882 12.5 9.99814 12.5H4.99907C4.11518 12.5 3.26749 12.8511 2.64248 13.4761C2.01748 14.1011 1.66635 14.9488 1.66635 15.8327V17.4991",
    stroke: "#155DFC",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49861 9.16543C9.33922 9.16543 10.8313 7.67333 10.8313 5.83272C10.8313 3.99211 9.33922 2.5 7.49861 2.5C5.658 2.5 4.16589 3.99211 4.16589 5.83272C4.16589 7.67333 5.658 9.16543 7.49861 9.16543Z",
    stroke: "#155DFC",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.33 17.4962V15.8299C18.3294 15.0914 18.0836 14.3741 17.6312 13.7905C17.1788 13.2069 16.5454 12.7901 15.8304 12.6055",
    stroke: "#155DFC",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3309 2.60938C14.0478 2.79293 14.6832 3.20985 15.1369 3.79441C15.5907 4.37898 15.8369 5.09794 15.8369 5.83794C15.8369 6.57795 15.5907 7.29691 15.1369 7.88147C14.6832 8.46604 14.0478 8.88296 13.3309 9.06651",
    stroke: "#155DFC",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBlue);
export default __webpack_public_path__ + "static/media/person_blue.836b8b1728ae75f3f3033a4cef2dbdea.svg";
export { ForwardRef as ReactComponent };